import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import axios from "axios";

Vue.use(Vuex);

const api = axios.create();

import indulineStore from "./induline-store";

const store = new Vuex.Store({
    state: {
        api,
        server_errors: { status: 0, errors: [] },
    },
    modules: {
        store: indulineStore
    },
    plugins: [
        new VuexPersistence({
            key: "induline-store"
        }).plugin
    ],
    strict: process.env.NODE_ENV !== "production"
});

export default store;
